import { NotificationOut } from '../api/types';

export interface FormattedNotification {
  title: string;
  message: string;
}

export function formatNotification(n: NotificationOut, locale: 'de' | 'en' | 'tr' | string): FormattedNotification {
  const p = n.payload_json || {};
  const kind = n.kind || '';

  // Get translations based on locale
  const isDe = locale === 'de';
  const isTr = locale === 'tr';

  // Helper to format currency
  const fmtCurrency = (val: any) => {
    if (val === undefined || val === null) return '0,00 €';
    const num = typeof val === 'number' ? val : parseFloat(String(val));
    if (isNaN(num)) return '0,00 €';
    return isDe || isTr
      ? `${num.toFixed(2).replace('.', ',')} €`
      : `€${num.toFixed(2)}`;
  };

  const ticketIdShort = typeof p.ticket_id === 'string' ? p.ticket_id.slice(-6) : '';

  switch (kind) {
    case 'bet_accepted': {
      const stakeStr = fmtCurrency(p.stake);
      const payoutStr = fmtCurrency(p.potential_payout);
      
      let title = 'Wette Angenommen';
      let message = `Ihre Wette (ID: ...${ticketIdShort}) wurde platziert. Einsatz: ${stakeStr}, Möglicher Gewinn: ${payoutStr}`;
      
      if (isTr) {
        title = 'Bahis Kabul Edildi';
        message = `Bahis kuponunuz (ID: ...${ticketIdShort}) kabul edildi. Yatırılan Tutar: ${stakeStr}, Olası Kazanç: ${payoutStr}.`;
      } else if (isDe) {
        title = 'Wette angenommen';
        message = `Ihre Wette (ID: ...${ticketIdShort}) wurde angenommen. Einsatz: ${stakeStr}, Möglicher Gewinn: ${payoutStr}.`;
      } else {
        title = 'Bet Accepted';
        message = `Your bet (ID: ...${ticketIdShort}) has been accepted. Stake: ${stakeStr}, Potential Payout: ${payoutStr}.`;
      }
      return { title, message };
    }
    
    case 'bet_won': {
      const payoutStr = fmtCurrency(p.payout || p.amount);
      
      let title = 'Wette Gewonnen';
      let message = `Herzlichen Glückwunsch! Ihre Wette (ID: ...${ticketIdShort}) hat gewonnen. Gewinn: ${payoutStr}.`;
      
      if (isTr) {
        title = 'Bahis Kazandı';
        message = `Tebrikler! Kuponunuz (ID: ...${ticketIdShort}) kazandı. Toplam Kazanç: ${payoutStr}.`;
      } else if (isDe) {
        title = 'Wette gewonnen';
        message = `Glückwunsch! Ihre Wette (ID: ...${ticketIdShort}) hat gewonnen. Gewinn: ${payoutStr}.`;
      } else {
        title = 'Bet Won';
        message = `Congratulations! Your bet (ID: ...${ticketIdShort}) won. Payout: ${payoutStr}.`;
      }
      return { title, message };
    }

    case 'bet_lost': {
      let title = 'Wette Verloren';
      let message = `Ihre Wette (ID: ...${ticketIdShort}) hat leider verloren.`;
      
      if (isTr) {
        title = 'Bahis Kaybetti';
        message = `Kuponunuz (ID: ...${ticketIdShort}) maalesef kaybetti.`;
      } else if (isDe) {
        title = 'Wette verloren';
        message = `Ihre Wette (ID: ...${ticketIdShort}) hat leider verloren.`;
      } else {
        title = 'Bet Lost';
        message = `Your bet (ID: ...${ticketIdShort}) lost.`;
      }
      return { title, message };
    }

    case 'wallet_deposit': {
      const amountStr = fmtCurrency(p.amount);
      let title = 'Einzahlung Erfolgreich';
      let message = `Ihre Einzahlung von ${amountStr} war erfolgreich.`;
      
      if (isTr) {
        title = 'Para Yatırma Başarılı';
        message = `${amountStr} tutarındaki para yatırma işleminiz başarıyla tamamlandı.`;
      } else if (isDe) {
        title = 'Einzahlung erfolgreich';
        message = `Ihre Einzahlung von ${amountStr} war erfolgreich.`;
      } else {
        title = 'Deposit Successful';
        message = `Your deposit of ${amountStr} was successful.`;
      }
      return { title, message };
    }

    case 'wallet_withdrawal': {
      const amountStr = fmtCurrency(p.amount);
      let title = 'Auszahlung Beantragt';
      let message = `Ihre Auszahlung von ${amountStr} wurde beantragt.`;
      
      if (isTr) {
        title = 'Para Çekme Talebi İletildi';
        message = `${amountStr} tutarındaki para çekme talebiniz işleme alındı.`;
      } else if (isDe) {
        title = 'Auszahlung beantragt';
        message = `Ihre Auszahlung von ${amountStr} wurde erfolgreich beantragt.`;
      } else {
        title = 'Withdrawal Requested';
        message = `Your withdrawal of ${amountStr} has been requested.`;
      }
      return { title, message };
    }

    default: {
      // Fallback
      const title = String(p.title || p.message || n.kind || 'Notification');
      const message = String(p.body || p.message || JSON.stringify(p));
      return { title, message };
    }
  }
}
